var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.longitude && _vm.longitude)?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getMapUrl())}}),_c('div',{staticClass:"font-size-14"},[_vm._v(_vm._s(_vm.description))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }